<template lang="html">

	<section class="ficha -empresa">
		
		<template v-if="!!data">

			<h2 class="ficha-title" :style="styles.colorBasic">{{$t('empresa')}}</h2>

			<article class="group">

				<h3 class="group-title" :style="styles.colorBasic">{{$t('datos_empresa')}}</h3>

				<div class="contenedor-data" v-if="!!data.cif">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('cif')}}</h4>
					<p>{{data.cif}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.nombreComercial">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('nombre_comercial')}}</h4>
					<p>{{data.nombreComercial}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.sector">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('sector')}}</h4>
					<p>{{data.sector}}</p>
				</div>
		

				<div class="contenedor-data" v-if="!!data.direccion">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('direccion')}}</h4>
					<p>{{data.direccion}}</p>
				</div>


				<div class="contenedor-data" v-if="!!data.localidad">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('localidad')}}</h4>
					<p>{{data.localidad}}</p>
				</div>


				<div class="contenedor-data" v-if="!!data.provincia">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('provincia')}}</h4>
					<p>{{data.provincia}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.cp">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('cp')}}</h4>
					<p>{{data.cp}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.paisDescripcion">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('pais')}}</h4>
					<p>{{data.paisDescripcion}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.web">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('web_empresa')}}</h4>
					<p><a :href="data.web" target="_blank">{{data.web}}</a></p>
				</div>


				<div class="contenedor-data -full" v-if="!!data.descripcion">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('descripcion')}}</h4>
					<p>{{data.descripcion}}</p>
				</div>
				
			</article>

			<article class="group" v-if="!!contactos && !!!brand.hideContactosEmpresa">

				<h3 class="group-title" :style="styles.colorBasic">{{$t('contacto_empresa')}}</h3>

					<template v-for="contacto in contactos">
					
					<div class="subgroup row-start">

						<div class="contenedor-data" v-if="contacto.nombre">
							<h4 class="data-title" :style="styles.colorBasic">{{$t('nombre_apellidos')}}</h4>
							<p>{{contacto.nombre}} {{contacto.apellidos}}</p>
						</div>

						<div class="contenedor-data" v-if="contacto.puesto">
							<h4 class="data-title" :style="styles.colorBasic">{{$t('puesto')}}</h4>
							<p>{{contacto.puesto}}</p>
						</div>

						<div class="contenedor-data" v-if="contacto.telefono1">
							<h4 class="data-title" :style="styles.colorBasic">{{$t('telefono')}}</h4>
							<p><a :href="'tel:'+contacto.telefono1">{{contacto.telefono1}}</a></p>
						</div>

							<div class="contenedor-data" v-if="contacto.email">
							<h4 class="data-title" :style="styles.colorBasic">{{$t('email')}}</h4>
							<p><a :href="'mailto:'+contacto.email">{{contacto.email}}</a></p>
						</div>

					</div>

				</template>



			</article>

		</template>

	</section>

</template>

<script lang="js">

	import {mapGetters, mapActions} from 'vuex';

	import onlyArrow  from '@/components/parts/icons/only-arrow';
	import arrowlink  from '@/components/parts/icons/arrow-link';

	export default  {
		name: 'ficha-empresa',
		props : ['data','contactos'],
		computed :{
			...mapGetters({
				styles : 'getStyles',
				brand : 'getBrand'
			})
		},
		components : {
			'only-arrow' : onlyArrow,
			'arrow-link' : arrowlink,
		}

	}
</script>

<style scoped lang="scss">
	.ficha-empresa {

	}
</style>



// WEBPACK FOOTER //
// src/components/views/ficha-empresa.vue